import { useId } from 'react'
import Svg, { Defs, LinearGradient, Path, Stop } from 'react-native-svg'

type AppIconPlusBoldProps = {
  size?: number
}

export function AppIconPlusBold({ size = 20 }: AppIconPlusBoldProps) {
  const id = useId()

  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        fill={`url(#${id})`}
        d="M10.6736 20.643V13.1261H3.32636C2.59372 13.1261 2 12.5186 2 11.7691C2.00005 11.0196 2.59375 10.4121 3.32636 10.4121H10.6736V3.35699C10.6736 2.60743 11.2674 2 12 2C12.7326 2 13.3264 2.60743 13.3264 3.35699V10.4121H20.6736C21.4062 10.4121 22 11.0196 22 11.7691C22 12.5186 21.4063 13.1261 20.6736 13.1261H13.3264V20.643C13.3264 21.3926 12.7326 22 12 22C11.2674 22 10.6736 21.3926 10.6736 20.643Z"
      />
      <Defs>
        <LinearGradient id={id} x1="2" y1="-16.9779" x2="21.2401" y2="32.09" gradientUnits="userSpaceOnUse">
          <Stop offset="0.16" stopColor="#7BB6FD" />
          <Stop offset="0.973693" stopColor="#0C75F7" />
        </LinearGradient>
      </Defs>
    </Svg>
  )
}
